import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    mapping: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            fieldRequired: true
          },
          currentNodeId: {
            type: 'number',
            fieldRequired: true
          },
          schoolName: {
            type: 'string',
            computed: true
          },
          edit: {
            type: 'boolean',
            computed: true
          }
        },
        allOf: [validationMessages]
      }
    }
  },
  allOf: [validationMessages]
};
